import React, { useContext, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { sidebarData } from "../lib/mock/sidebarMock";
import { useDispatch, useSelector } from "react-redux";
import { fetchLogout } from "../redux/slices/logoutSlice";
import { ThemeContext } from "../context/themeContext";
import Tooltip from "../components/Tooltip";

const scanOnlyMemberships = ["SCAN PRO", "SCAN PRO+"];

const Sidebar = ({ visible = false, onClose = () => {} }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { theme } = useContext(ThemeContext);

  const logoutData = useSelector((state) => state.logout.logout);
  const homeDetails = useSelector((state) => state.auth.homeData);
  const authDetails = useSelector((state) => state.auth.authData);
  const isVaUser = useSelector((state) => {
    const vaAccess = state.auth.authData?.va_access;
    return (
      vaAccess === true ||
      vaAccess === "true" ||
      vaAccess === 1 ||
      vaAccess === "1"
    );
  });
  const currentMembership =
    homeDetails?.membership || authDetails?.membership || "";
  const isScanOnlyMember = scanOnlyMemberships.includes(currentMembership);
  const avatarSrc = homeDetails?.avatar || authDetails?.avatar || "";
  const displayName =
    homeDetails?.name ||
    authDetails?.name ||
    authDetails?.username ||
    authDetails?.email ||
    "";

  const handleLogout = () => {
    dispatch(fetchLogout());
  };

  useEffect(() => {
    if (logoutData && logoutData?.status === "unauthorized") {
      navigate("/login");
    }
  }, [logoutData]);

  const findIcon = (item, isActive) => {
    if (isActive) {
      return theme === "dark" ? item.enableDarkIcon : item.enableLightIcon;
    } else {
      return theme === "dark" ? item.darkIcon : item.lightIcon;
    }
  };

  const iconClass = (item, isActive) => {
    if (isActive) {
      return "!bg-secondary";
    } else if (item.disable) {
      return "disabled-link";
    } else {
      return "";
    }
  };

  const baseMenuItems = isScanOnlyMember
    ? sidebarData.filter((item) => {
        if (!item.link) return false;
        return (
          item.link === "/settings" ||
          item.link.startsWith("/wholesale") ||
          item.link === "/guide"
        );
      })
    : sidebarData;

  const menuItems = isVaUser
    ? baseMenuItems.filter((item) => item.link !== "/settings")
    : baseMenuItems;

  return (
    <div
      className={`sidebar bg-bgColor border-b-[1px] border-borderBottom transform transition-transform ${
        visible ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      <div className="logo-details">
        <div className="logo_name">Menü</div>
        <i className="bx bx-chevron-left cursor-pointer" id="btn" onClick={onClose}></i>
      </div>
      <ul className="nav-list ">
        {menuItems.map((item, index) => {
          const isActive = location.pathname.startsWith(item.link);
          const iconSrc = findIcon(item, isActive);

          return (
            <li
              key={index}
              className={`flex justify-center`}
            >
              <Link
                to={item.link}
                className={`hover:bg-hoverbgColor p-2 flex items-center gap-4 tooltip-on-hover !size-9
                ${iconClass(item, isActive)}`}
              >
                <img
                  className="flex items-center justify-center !h-6"
                  src={iconSrc}
                  alt="icon"
                  width={item.width}
                />
                <span className="links_name !text-left">{item.title}</span>
              </Link>
              <span className="tooltip bg-bgTooltip text-textTooltip border border-borderTootip">
                {item.title}
              </span>
              <Tooltip label={item.title} />
            </li>
          );
        })}

        <li className="profile !bg-background flex items-center">
          <div className="profile-details">
            {avatarSrc ? (
              <img
                src={avatarSrc}
                alt="Profilbild"
                className="rounded-full w-[45px] h-[45px]"
              />
            ) : (
              <div className="rounded-full w-[45px] h-[45px] bg-primary/10 text-primary flex items-center justify-center">
                <i className="bx bx-user text-xl"></i>
              </div>
            )}
            <div className="text-[14px] ml-3 whitespace-nowrap">
              <div className="text-textTitle capitalize">
                {displayName}
              </div>
              <div className="text-textTitle capitalize">
                {currentMembership}
              </div>
            </div>
          </div>
          <div className="cursor-pointer" onClick={handleLogout}>
            <i
              className="bx bx-log-out bg-bgColor border-r-[1px] border-borderBottom"
              id="log_out"
            ></i>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
